import Link from 'components/commercetools-ui/atoms/link';
import { Button } from 'components/ui/button';
import { useRouter } from 'next/navigation'; // Importa useRouter

type CrossSellModalFooterProps = {
  moreCompatible: { label: string; slug: string };
  onClose: () => void;
};

const CrossSellModalFooter = ({ moreCompatible, onClose }: CrossSellModalFooterProps) => {
  const router = useRouter();

  function onViewCart() {
    onClose();
    router.push('/cart');
  }

  return (
    <div className="mx-auto mt-11 flex w-full flex-col items-center justify-center gap-5 lg:flex-row lg:gap-10">
      {!!moreCompatible.label && (
        <Link
          link={moreCompatible.slug}
          aria-label={`More about ${moreCompatible.label}`}
          className="disabled:opacity-30] sm:s-max mb-0 flex h-11 w-full cursor-pointer items-center justify-center rounded-[6px] bg-[#404040] px-8 text-sm font-semibold text-white hover:bg-[#333] disabled:cursor-not-allowed sm:w-max"
        >
          {moreCompatible.label}
        </Link>
      )}

      <Button
        type="button"
        onClick={onViewCart}
        aria-label="View Cart"
        className="h-11 w-full rounded border border-[#404040] bg-white px-5 py-2 text-center text-sm font-normal leading-[17px] sm:w-max"
      >
        Go to Cart & Checkout
      </Button>
    </div>
  );
};

export default CrossSellModalFooter;
